import { createAsyncThunk, ThunkDispatch } from '@reduxjs/toolkit';
import personLinkService from './PersonLink.service';
import { PersonLinkEditState } from './PersonLink.type';
import { errorHandlerThunk } from '../../App/App.thunk';

export const getPersonLinkTypesThunk = createAsyncThunk(
  'personLink/getPersonLinkTypesThunk',
  async (_: any, thunkAPI) => {
    const response = await personLinkService.getTypes();
    return response.data;
  },
);

export const syncPersonLinkThunk =
  (personId: number | string, links: PersonLinkEditState[]) =>
  (dispatch: ThunkDispatch<any, any, any>) => {
    return personLinkService
      .sync(personId, links)
      .then(() => {
        return true;
      })
      .catch(err => {
        dispatch(errorHandlerThunk(err));
        return false;
      });
  };
